import { render, staticRenderFns } from "./CadastroRentab.vue?vue&type=template&id=5d48fb64&"
import script from "./CadastroRentab.vue?vue&type=script&lang=js&"
export * from "./CadastroRentab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports